import styled from 'styled-components';
import { ColumnFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';

export const BreakdownItem = styled(ColumnFlexContainer)<{ isMobile: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: ${({ theme: { spacing } }) => spacing(1)};
  border-radius: ${({ theme: { spacing } }) => spacing(2)};
  background-color: ${({ theme: { color } }) => color.backgroundSelectedDark};
  padding: ${({ isMobile, theme: { spacing } }) => (isMobile ? spacing(2, 0) : spacing(2, 2))};
`;

export const MetricContainer = styled(ColumnFlexContainer)<{ isMobile: boolean }>`
  box-sizing: border-box;
`;
